import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { formikValidation, formikinitialvalues, replaceUnderscore } from "../../../../../CommonFunction/common";
import Input from "../../../../Components/Input/Input";
import "./AddSubMenuSection.scss";
const { gql } = require("@apollo/client");
export let GetModule = gql`
  query GetAllMenuSearch($keyword: String!) {
    getAllMenuSearch(keyword: $keyword) {
      Menu_Name
      _id
      Unique_Id
      Search_Value
      Serial_No
    }
  }
`;
// Alternate_Name
// Menu_Name
const AddSubMenuMasterSection = (props) => {
  const [fields, setfields] = useState(props.inputfields);
  const [alldata, setalldata] = useState<any>({});
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.fielddata) {
      let arr: any = [];
      for (var a = 0; a < fields.length; a++) {
        arr.push({ [fields[a].name]: props.fielddata[fields[a].name] });
        formik.setFieldValue(fields[a].name, props.fielddata[fields[a].name]);
      }
      let obj = {};

      for (var l = 0; l < arr.length; l++) {
        let temp = arr[l];
        for (var key in temp) {
          obj[key] = temp[key];
        }
      }
      if (obj) {
        setalldata(obj);
      }
    }
  }, [props.fielddata]);

  useEffect(() => {
    dispatch({
      type: "Add_FormFieldData",
      payload: { data: alldata, key: props.Type },
    });
  }, [alldata]);

  const validate = (values: any) => {
    setalldata(values);
  };

  const formik = useFormik({
    initialValues: formikinitialvalues(fields),
    validationSchema: formikValidation(fields),
    validate,
    onSubmit: (values) => { },
  });

  return (
    <div className="Addloadsection2">
      <div className="headingaddloadsection2">{replaceUnderscore(props.Type)}</div>
      {/* <GetLoactioWithPincode/> */}
      {fields.length > 0 && (
        <form onSubmit={formik.handleSubmit} autoComplete="off">
          <div className="contentAddload6">
            <div className="SubMenuDropdown">
              {fields?.map((e) => {
                return (
                  <div key={e.id}>
                    <Input
                      EMTQuery=""
                      checked={""}
                      InputConfig={e}
                      JurnalDropdown=""
                      Section_Type=""
                      disabled=""


                      transactions=""
                      PaymentProcess=""
                      TypeOfPortal={props.TypeOfPortal}
                      name={e.name}
                      value={alldata[e?.name]}
                      label={e.label}
                      className={"inputwidthAddload"}
                      type={e.type}
                      modalform={true}
                      handleInputChange={(evt) => {
                        formik.handleChange(evt);
                      }}
                      dropdowndata={e?.dropdowndata}
                      handleBlur={formik.handleBlur}
                      touched={formik.touched[e.name]}
                      error={formik.errors[e.name]}
                      max={e.max ? e.max : undefined}

                      notSearchable={""}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </form>
      )}
    </div>
  );
};
export default AddSubMenuMasterSection;

